import React, { useState } from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

export function ToggleSwitch({ values = {} }: { values?: FieldValues }) {
  const [isOn, setIsOn] = useState(false)
  const stiffness = values.stiffness ?? 500
  const damping = values.damping ?? 30
  const onColor = values.onColor ?? 'bg-green-500'
  const offColor = values.offColor ?? 'bg-gray-300'
  const knobSize = values.knobSize ?? 28

  return (
    <div className="flex items-center justify-center h-full">
      <button
        onClick={() => setIsOn(!isOn)}
        className={`w-16 h-9 rounded-full p-1 flex cursor-pointer transition-colors duration-200 ${
          isOn ? `${onColor} justify-end` : `${offColor} justify-start`
        }`}
      >
        <motion.div
          layout
          transition={{ type: 'spring', stiffness, damping }}
          className="bg-white rounded-full shadow-md"
          style={{ width: knobSize, height: knobSize }}
        />
      </button>
    </div>
  )
}
